import type { CSSObject } from "tss-react"

import { PRINT_PLAIN_BACKGROUND_CLASS } from "../../../../../shared/components/print/printPageOnly"

export enum HomePrintSection {
    BOOKINGS = "print-bookings",
    GUEST_LIST = "print-guest-list",
}

export function hiddenWhenPrinting(section: HomePrintSection): CSSObject {
    return {
        "@media print": {
            [`body.${section} &`]: {
                display: "none",
            },
        },
    }
}

export function visibleOnlyWhenPrinting(section: HomePrintSection): CSSObject {
    return {
        display: "none",
        "@media print": {
            [`body.${section} &`]: {
                display: "block",
            },
        },
    }
}

function clearPrintSections() {
    document.body.classList.remove(PRINT_PLAIN_BACKGROUND_CLASS, ...Object.values(HomePrintSection))
}

export function printHomeSection(section: HomePrintSection, print: () => void) {
    clearPrintSections()
    document.body.classList.add(PRINT_PLAIN_BACKGROUND_CLASS, section)
    window.addEventListener("afterprint", clearPrintSections, { once: true })
    print()
}
